import React from "react";
import get from "lodash/get";
import { number, object, string } from "prop-types";
import { Link } from "@quintype/components";
import { UserFallbackIcon } from "../../../arrow/components/Svgs/user-fallback-icon";

import "./people-card.m.css";

const PeopleCard = ({ card, cdnImage, index }) => {
  const { name, slug } = card;
  const imgUrl = get(card, ["photo", "0", "key"], null);
  // No longer need qtState or pageType since we're using static values

  let isTracking = false;

  const handlePeopleClick = () => {
    if (isTracking) return;
    isTracking = true;

    setTimeout(() => {
      isTracking = false;
    }, 300);

    if (typeof window !== "undefined" && window.dataLayer) {
      // Push to dataLayer with new format for people list interactions
      window.dataLayer.push({
        event: "dl_people_list_interactions",
        link_text: name.toLowerCase(),
        link_position: index + 1,
        event_action: "profile_select",
        category: "people",
        sub_category: "NA",
        template_name: "listing",
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
        eventCallback: () => {
          window.location.href = `people/${slug}`;
        },
      });

      setTimeout(() => {
        window.location.href = `people/${slug}`;
      }, 100);
    }
  };

  return (
    <Link
      href={`people/${slug}`}
      aria-label="image-fallback"
      styleName="wrapper"
      disableAjaxLinks={true}
      onMouseDown={handlePeopleClick}
      onTouchStart={handlePeopleClick}
    >
      <div styleName="imageIcon">
        {imgUrl ? <img key={`${name}-${index}`} src={`${cdnImage}/${imgUrl}?w=120&q=70`} alt={name} title={name} width="80" height="80" loading="lazy" /> : <UserFallbackIcon />}
      </div>
      <div styleName="text">
        <div styleName="name">{name}</div>
      </div>
    </Link>
  );
};

PeopleCard.propTypes = {
  card: object,
  cdnImage: string,
  index: number,
};

export default PeopleCard;
